import { useDispatch, useSelector } from 'react-redux';
import { useCallback, Dispatch } from 'react';
import * as actions from '../actions/shipment-group';
import { Action } from '../actions';
import { StoreState } from '../state';
import { CreateShipmentGroupConfigurationInput, UpdateShipmentGroupConfigurationInput, DeleteShipmentGroupConfigurationInput } from '../../ports/ShipmentGroupService';

export const useShipmentGroupConfigurations = () => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const [isShipmentGroupConfigurationsLoading, shipmentGroupConfigurations] = useSelector(
    (state: StoreState) => [
      state.shipmentGroups.shipmentGroupConfigurations.isLoading,
      state.shipmentGroups.shipmentGroupConfigurations.all,
    ] as const,
  );

  const createShipmentGroupConfiguration = useCallback(
    (input: CreateShipmentGroupConfigurationInput) =>
      dispatch(actions.createShipmentGroupConfiguration.request(input)),
    [dispatch],
  );

  const updateShipmentGroupConfiguration = useCallback(
    (input: UpdateShipmentGroupConfigurationInput) =>
      dispatch(actions.updateShipmentGroupConfiguration.request(input)),
    [dispatch],
  );

  const deleteShipmentGroupConfiguration = useCallback(
    (input: DeleteShipmentGroupConfigurationInput) =>
      dispatch(actions.deleteShipmentGroupConfiguration.request(input)),
    [dispatch],
  );

  const getShipmentGroupConfigurations = useCallback(
    () => dispatch(actions.getShipmentGroupConfigurations.request()),
    [dispatch],
  );

  return {
    shipmentGroupConfigurations,
    createShipmentGroupConfiguration,
    updateShipmentGroupConfiguration,
    deleteShipmentGroupConfiguration,
    getShipmentGroupConfigurations,
    isShipmentGroupConfigurationsLoading,
  };
};
